/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SecReviewValidationError } from './SecReviewValidationError';
import {
    SecReviewValidationErrorFromJSON,
    SecReviewValidationErrorFromJSONTyped,
    SecReviewValidationErrorToJSON,
} from './SecReviewValidationError';

/**
 * 
 * @export
 * @interface SecReviewHTTPValidationError
 */
export interface SecReviewHTTPValidationError {
    /**
     * 
     * @type {Array<SecReviewValidationError>}
     * @memberof SecReviewHTTPValidationError
     */
    detail?: Array<SecReviewValidationError>;
}

/**
 * Check if a given object implements the SecReviewHTTPValidationError interface.
 */
export function instanceOfSecReviewHTTPValidationError(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SecReviewHTTPValidationErrorFromJSON(json: any): SecReviewHTTPValidationError {
    return SecReviewHTTPValidationErrorFromJSONTyped(json, false);
}

export function SecReviewHTTPValidationErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecReviewHTTPValidationError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'detail': !exists(json, 'detail') ? undefined : ((json['detail'] as Array<any>).map(SecReviewValidationErrorFromJSON)),
    };
}

export function SecReviewHTTPValidationErrorToJSON(value?: SecReviewHTTPValidationError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'detail': value.detail === undefined ? undefined : ((value.detail as Array<any>).map(SecReviewValidationErrorToJSON)),
    };
}

